import React, { useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { shallowEqual } from 'react-redux';
import { setLayoutSettings } from '../../../redux/projectSlice';
import {
  PAPER_SIZE_OPTIONS,
  LAYOUT_DIRECTION_OPTIONS,
  VERTICAL_ALIGN_OPTIONS,
  DEFAULT_LAYOUT_SETTINGS,
} from '../../../constants/projectTypes';
import './ToolLayout.css';

const ToolLayout = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  // Mevcut layout ayarlarını oku (yoksa default)
  const settings = useSelector(
    (state) => ({
      ...DEFAULT_LAYOUT_SETTINGS,
      ...(state.project?.projectMetadata?.layoutSettings || {}),
    }),
    shallowEqual
  );

  const update = useCallback(
    (patch) => dispatch(setLayoutSettings(patch)),
    [dispatch]
  );

  return (
    <div className={`toolLayoutAccordion ${isOpen ? 'open' : 'closed'}`}>
      {isOpen && (
        <div className="toolLayout-content">
          {/* Kağıt Boyutu */}
          <div className={`toolLayout-field ${settings.paperSize !== 'auto' ? 'toolLayout-field--highlighted' : ''}`}>
            <label>Kağıt {settings.paperSize !== 'auto' && <span style={{ color: '#1abc9c' }}>● {settings.paperSize}</span>}</label>
            <select
              className="toolLayout-select"
              value={settings.paperSize}
              onChange={(e) => update({ paperSize: e.target.value })}
            >
              {PAPER_SIZE_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>

          {/* Sıralama Yönü */}
          <div className="toolLayout-field">
            <label>Yön</label>
            <select
              className="toolLayout-select"
              value={settings.direction}
              onChange={(e) => update({ direction: e.target.value })}
            >
              {LAYOUT_DIRECTION_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>

          {/* Boşluk */}
          <div className="toolLayout-field">
            <label>Boşluk</label>
            <input
              type="number"
              className="toolLayout-input"
              value={settings.docSpacing}
              min={0}
              max={500}
              step={5}
              onChange={(e) => {
                const v = parseInt(e.target.value, 10);
                if (Number.isFinite(v) && v >= 0 && v <= 500) update({ docSpacing: v });
              }}
            />
          </div>

          {/* Hizalama */}
          <div className="toolLayout-field">
            <label>Hizalama</label>
            <select
              className="toolLayout-select"
              value={settings.verticalAlign}
              onChange={(e) => update({ verticalAlign: e.target.value })}
            >
              {VERTICAL_ALIGN_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>{opt.label}</option>
              ))}
            </select>
          </div>

          {/* Reset */}
          <button
            className="toolLayout-reset"
            onClick={() => update(DEFAULT_LAYOUT_SETTINGS)}
            title="Varsayılana sıfırla"
          >
            ⟲
          </button>
        </div>
      )}

      <div className="toolLayout-toggle">
        <button
          className="toolButton toggleArrowButton"
          onClick={() => setIsOpen((prev) => !prev)}
          title={`Kağıt: ${settings.paperSize === 'auto' ? 'Otomatik' : settings.paperSize}`}
        >
          {isOpen
            ? '◀'
            : (
              <span className="toolLayout-toggle-label">
                Layout
                <span className="toolLayout-toggle-badge">
                  {settings.paperSize === 'auto' ? 'Auto' : settings.paperSize}
                </span>
                ▶
              </span>
            )}
        </button>
      </div>
    </div>
  );
};

export default ToolLayout;
